module.exports = __webpack_public_path__ + "img/people-37-min.db4204d5.png";